import { ComponentType } from "../../types/Questionnaire";

export const sequence = {
    sequence_empty_list: 'Aucun questionnaire n\'est disponible pour cette période.',
};